// ARLO Brand Colors
export const COLORS = {
  PURPLE: '#4f387e',
  PURPLE_DARK: '#3a285e',
  ORANGE: '#c35f2d',
  ORANGE_DARK: '#a34f23',
  GREY_FORMULA: '#8c8793',
  PURPLE_OVERLAY: 'rgba(79, 56, 126, 0.2)',
  WHITE_BORDER_TRANSPARENT: 'rgba(255, 255, 255, 0.2)',
  CHART_HOLIDAY: '#e8a87c',
  CHART_SUPERVISOR: '#d4d4d8',
  CHART_NON_PRODUCTIVE: '#a8a8b0',
  CHART_NON_ESSENTIAL: '#71717a',
  CHART_GRID: '#e2e8f0',
  CHART_TICK: '#64748b',
};

// Slider Configuration
export const SLIDER_CONFIG = {
  MANAGED_COST: { min: 50, max: 90, step: 5, default: 70 },
  SELF_DELIVERY_RATE: { min: 20, max: 80, step: 1, default: 45 },
  HOLIDAY_PAY: { min: 0, max: 25, step: 1, default: 17 },
  SUPERVISOR_COST: { min: 0, max: 20, step: 1, default: 5 },
  NON_PRODUCTIVE: { min: 0, max: 30, step: 1, default: 10 },
  NON_ESSENTIAL: { min: 0, max: 20, step: 1, default: 20 },
};

// Input Modes
export const MODE_MANAGED = 'managed';
export const MODE_SELF_DELIVERY = 'self_delivery';

// Risk Positions
export const RISK_OPTIONS = [
  {
    key: 'low',
    index: 0,
    shortLabel: 'Low Risk Appetite',
    label: 'I want most installation and delivery risk priced in upfront.',
    description: 'You prefer cost certainty and want a realistic allowance made for delays, coordination issues, rework, access challenges and project disruption.',
    allowancePct: 25,
    dynamicMessage: 'You have chosen to prioritise cost certainty. The comparison includes a larger allowance for potential project disruption and unforeseen costs.',
  },
  {
    key: 'balanced',
    index: 1,
    shortLabel: 'Balanced Risk',
    label: 'I am comfortable accepting some project risk.',
    description: 'You recognise that issues can occur and want a reasonable contingency included in the comparison.',
    allowancePct: 12.5,
    dynamicMessage: 'You have chosen a balanced approach that recognises typical project risks without assuming worst-case outcomes.',
  },
  {
    key: 'high',
    index: 2,
    shortLabel: 'High Risk Appetite',
    label: 'I am comfortable carrying most project risk myself.',
    description: 'You prefer the lowest upfront cost and accept responsibility for costs that may arise if issues occur during installation.',
    allowancePct: 5,
    dynamicMessage: 'You have chosen to retain most project risk. While this produces the lowest comparison cost, any delays, rework or coordination issues remain your responsibility.',
  },
];

export const DEFAULT_RISK_INDEX = 1;

// Chart Configuration
export const CHART_CONFIG = {
  HEIGHT: 350,
  MARGIN: { top: 20, right: 30, left: 20, bottom: 5 },
  LABEL_FONT_SIZE: 16,
  LABEL_FONT_WEIGHT: 700,
  ZERO_RADIUS: [0, 0, 0, 0],
  TOOLTIP_STYLE: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '0px',
  },
  GRID_DASH: '3 3',
};

// External URLs
export const URLS = {
  ARLO_LOGO: 'https://irp.cdn-website.com/c761511b/dms3rep/multi/ARLO_Express+Sheetmetals+Logo_REV.svg',
  HERO_IMAGE: 'https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZHVjdGluZyUyMGluc3RhbGxhdGlvbiUyMGh2YWN8ZW58MHx8fHwxNzgwNDM1MzUxfDA&ixlib=rb-4.1.0&q=85',
  CONTACT_PAGE: 'https://www.arloexpressmetals.com/contact-us',
};

export const PERCENT_DIVISOR = 100;
